export const HEADER_HEIGHT = 48;
export const TAB_HEIGHT = 48;
export const HANACARD_TAB_HEIGHT = 48;
export const HANACARD_SUBTAB_HEIGHT = 52;

export const BOTTOM_NAVIGATION_HEIGHT = 48;
export const GME_BOTTOM_PADDING = 56 * 1.5;
